module.exports = __webpack_public_path__ + "static/img/0402_03.81297b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0402_03.png
// module id = Rb7C
// module chunks = 1